import { PageCoreContext, PageLocation } from './selectPageContext'

/**
 * Where non-React code asks "what page is the user on?". Mirrors
 * telemetryContext: a module-level getter registered from Redux middleware,
 * not a React Context — consumers are send-time callbacks and thunks, so a
 * provider would cost re-renders for readers that never render.
 */
let getPageContextFn: (() => PageCoreContext) | undefined

export const setPageContextGetter = (getter: () => PageCoreContext): void => {
  getPageContextFn = getter
}

/** Null until the getter is registered (first dispatch). */
export const getCurrentPageContext = (): PageCoreContext | null =>
  getPageContextFn ? getPageContextFn() : null

/**
 * The app has no history singleton — plain BrowserRouter, no custom history
 * object — so outside a component `window.location` is the only current
 * location. Matches how the CoSell thunks already read `pathname`.
 */
export const getWindowLocation = (): PageLocation =>
  typeof window === 'undefined'
    ? { pathname: '', search: '' }
    : { pathname: window.location.pathname, search: window.location.search }
